import React from "react";
import { motion } from "framer-motion";
import { springVariants, springViewport } from '../utils/framerVariants';

const Quotes = ({ data, location }) => {
  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de/');

  const containerClasses = "container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl pb-16 md:pb-24 lg:pb-32 xl:pb-48 px-4 md:px-24 lg:px-24 xl:px-24";
  const quoteClasses = isGerman ? "quote text-center text-headline tracking-headline leading-[1.15] font-normal" : "font-normal text-headline tracking-headline leading-[1.15] text-center";
  const quoteText = isGerman ? `„${data.Quote}“` : `“${data.Quote}”`;

  return (
    <article className={containerClasses}>
      <blockquote className={quoteClasses}>
        {data.Quote && (
          <motion.div
            variants={springVariants}
            initial="invisible"
            whileInView="visible"
            viewport={springViewport}
          >
            {quoteText}
          </motion.div>
        )}
        {data.Author && (
          <motion.cite
            variants={springVariants}
            initial="invisible"
            whileInView="visible"
            className="text-text tracking-text leading-text mt-8 md:mt-12 block max-w-md mx-auto"
            viewport={springViewport}
          >
            {data.Author}
          </motion.cite>
        )}
      </blockquote>
    </article>
  );
};

export default Quotes;
